import EvHybridInformation from 'src/components/ConnectedVehicle/EvHybridInformation/EvHybridInformation';
import { connect } from 'react-redux';
import { IStoreState } from 'src/store';

const mapStateToProps = (state: IStoreState) => ({
    connectedVehicle: state.ConnectedVehicle.ConnectedVehicleRec,
});

export default connect(mapStateToProps)(EvHybridInformation);